module.exports = __webpack_public_path__ + "static/media/logo-light-en.e917fe60.svg";